import Role from '../role';

export default class Operator extends Role {
  constructor(id) {
    super({ id, name: 'operator', translations: { fr: 'opérateur' } });
  }

  // eslint-disable-next-line class-methods-use-this
  can() {
    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  assignableRoles() { return []; }
}
